<template>
  <div id="aid-order-review">
    <div class="toolbar">
      <a-button @click="print" type="primary" shape="circle" icon="printer"></a-button>
    </div>
    <div class="orders">
      <template v-for="shop in shops">
        <div class="sk-card" :key="'floorplan'+shop.id">
          <h4 class="h4">
            <span>{{shop.shop_no }} {{shop.title}}</span>
            <div class="suffix">
              <img src="@/assets/senkoo.png" style="width:96px;height:16px;" />
            </div>
          </h4>
          <div class="total">
            <span>画面总数 {{shop.total.count}}</span>
            <span>总平方数 {{shop.total.area}}</span>
            <span>点位数量 {{shop.total.points||shop.current.length}}</span>
          </div>
          <div v-for="item in shop.images" :key="'floorplan-'+item.id+item.kind">
            <div class="floor-summary">
              <span>楼层{{item.kind}}</span>
              <span>点位 {{item.points.length}}</span>
            </div>
            <div class="img-shop">
              <Floorplan :item="item" :shop="shop" :readOnly="true" />
            </div>
            <div class="point-table" :key="'points-table'+shop.id">
              <PointView :points="item.points" />
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import Floorplan from "./Floorplan";
import PointView from "./PointView";
export default {
  props: { id: [String, Number] },
  components: { Floorplan, PointView },
  data() {
    return {
      shops: [],
      shop_no: ""
    };
  },
  created() {
    this.shop_no = this.$route.query.no;
    this.getShops();
  },
  methods: {
    print() {
      window.print();
    },
    getPosInfo(position) {
      const pos = position.split("-");
      return { shop_no: pos[0], kind: pos[1], x: pos[2], y: pos[3] };
    },
    getShops(param = {}) {
      if (this.shop_no) {
        param.no = this.shop_no;
      }
      if (this.id) {
        param.tape_project_id = this.id;
      }
      this.$store.dispatch("shop/getShopMap", param).then(res => {
        this.shops = res.items.map((m, sidx) => {
          m.current = m.current.map(mc => {
            const pos = this.getPosInfo(mc.point);
            const size = mc.size.split("*");
            return {
              ...mc,
              ...pos,
              shop_floor: pos.kind,
              w: size[0] - 0,
              h: size[1] - 0
            };
          });
          m.total = m.current.reduce(
            (p, c) => {
              p.count += c.count;
              if (c.w > 0 && c.h > 0 && c.count > 0) {
                p.area += (c.w / 1000) * (c.h / 1000) * c.count;
              }
              p.points += 1;
              return p;
            },
            { count: 0, area: 0, points: 0 }
          );
          console.log("current:", m.total, m.current);
          m.images = m.images.map(mi => {
            mi.points = m.current.filter(
              f => f.shop_id == m.id && f.kind == mi.kind
            );
            return mi;
          });
          return m;
        });
        console.log("point image data:", this.shops, res);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
#aid-order-review {
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  .toolbar {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 100;
    height: 40px;
    line-height: 40px;
  }
  .orders {
    background: #fff;
    width: 70%;
    margin: 40px auto 0;
    display: flex;
    flex-direction: column;
    // border: 1px dashed red;
    padding: 0 30px;
    .sk-card {
      background: #fff;
      border-radius: 4px;
      margin-bottom: 30px;
      .h4 {
        height: 70px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #dcdcdc;
        margin: 0;
        .suffix {
          > * {
            margin-left: 12px;
          }
        }
      }
      .total {
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 500;
        color: #333;
        // border: 1px dashed red;
        > span {
          margin: 0 25px;
        }
      }
      .floor-summary {
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: 500;
        color: #333;
      }
      .img-shop {
        padding: 10px;
        background: #f5f5f5;
        margin-bottom: 20px;
      }
    }
  }
}
@media print {
  #aid-order-review {
    .toolbar {
      visibility: hidden;
    }
    .orders {
      width: 100%;
      margin: 0;
      .img-shop {
        page-break-inside: avoid;
      }
    }
  }
  @page {
    margin: 0;
  }
}
</style>